import React from "react";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import rawToReact from "../../../utils/rawToReact";
import "./radioOptions.scss";

interface RadioOptionsProps {
    setInputValue: (nombreId, value, type) => void;
    titleOptions?: string;
    textoTerminos?: any;
    nombreId: string;
    type: string;
    options: any;
    selectedOption?: string;
    value: string;
  }

const RadioOptions = (props: RadioOptionsProps) => {

    const { titleOptions, nombreId, options, value, type, setInputValue, textoTerminos } = props

    return (
        <div className="a-radio-options">
            <p>{titleOptions}</p>
            {textoTerminos && (
                <span className="a-radio-options__texto-terminos">
                    {rawToReact(textoTerminos, contentfulRenderOptions)}
                </span>
            )}
            {options.map((option, index) => (
                <div className="options" key={index}>
                    <input
                        type="radio"
                        id={nombreId + "_" + option}
                        value={option}
                        name={nombreId}
                        checked={value === option}
                        onChange={(e) =>
                            setInputValue(
                                nombreId,
                                e.target.value,
                                type
                            )
                        }
                    />
                    <span>
                        {option.includes("-") ? (
                            <div style={{ lineHeight: "20px"}}>
                                <strong>{option.split("-")[0].trim()}</strong>
                                <br />
                                {option.split("-").slice(1).join("-").trim()}
                            </div>
                        ) : (
                            option
                        )}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default RadioOptions;